import { ROUTES as AI_CODING_OUTPUTS_ROUTES } from "@/ai-coding-outputs/navigation";
import { ROUTES as ADMIN_CODING_ROUTES } from "@/admin-coding-dashboard/navigation";
import { ROUTES as CLINICAL_CODE_RULES_ROUTES } from "@/clinical-code-rules/navigation";
import { ROUTES as RAW_FILES_VIEWER_ROUTES } from "@/raw-files-viewer/navigation";
import { ROUTES as FORM_READ_CORRECTIONS_ROUTES } from "@/form-read-corrections/navigation";
import { ROUTES as RELEVANCE_REVIEW_ROUTES } from "@/relevance-review/navigation";
import { ROUTES as TEST_DATA_ROUTES } from "@/test-data/navigation";
import { ROUTES as WRITE_BACK_MANAGEMENT_ROUTES } from "@/write-back-management/navigation";
import { Separator } from "@/components/ui/separator";
import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { supabase } from "@/integrations/supabase/client";
import { ROUTES as USER_ROUTES } from "@/user/navigation";
import {
  BarChart3,
  ClipboardCheck,
  FileCheck,
  Code,
  Database,
  FileSearch,
  FileText,
  GraduationCap,
  Home,
  List,
  LogOut,
  Search,
  Send,
  Settings,
  TestTube,
  AlertTriangle,
  BookOpen,
  Users,
} from "lucide-react";
import { useCallback } from "react";
import { Link, useNavigate } from "react-router";

function AdminSidebarMenuItems() {
  const navigate = useNavigate();
  const handleLogout = useCallback(async () => {
    await supabase.auth.signOut();
    navigate("/auth");
  }, [navigate]);

  return (
    <>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Home">
          <Link to="/">
            <Home className="h-4 w-4" />
            <span>Home</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <div className="px-2 py-1">
        <Separator orientation="horizontal" />
      </div>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Coding Outputs">
          <Link to={`${AI_CODING_OUTPUTS_ROUTES.aiCodingOutputs.route}`}>
            <FileText className="h-4 w-4" />
            <span>Coding Outputs</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Coding Dashboard">
          <Link to={`${ADMIN_CODING_ROUTES.codingDashboard.route}`}>
            <BarChart3 className="h-4 w-4" />
            <span>Coding Dashboard</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Raw Files Viewer">
          <Link to={`${RAW_FILES_VIEWER_ROUTES.rawFilesViewer.route}`}>
            <FileSearch className="h-4 w-4" />
            <span>Raw Files Viewer</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Relevance Review">
          <Link to={RELEVANCE_REVIEW_ROUTES.relevanceReview.route}>
            <ClipboardCheck className="h-4 w-4" />
            <span>Relevance Review</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Form-read Corrections">
          <Link to={FORM_READ_CORRECTIONS_ROUTES.formReadCorrections.route}>
            <FileCheck className="h-4 w-4" />
            <span>Form-read Corrections</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Approved Results">
          <Link to={`${AI_CODING_OUTPUTS_ROUTES.unwrittenEncounterReview.route}`}>
            <Send className="h-4 w-4" />
            <span>Approved Results</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Write-backs">
          <Link to={WRITE_BACK_MANAGEMENT_ROUTES.writeBackManagement.route}>
            <AlertTriangle className="h-4 w-4" />
            <span>Write-backs</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <div className="px-2 py-1">
        <Separator orientation="horizontal" />
      </div>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Customer Management">
          <Link to="/admin/customer-management">
            <Users className="h-4 w-4" />
            <span>Customer Management</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Encounter MRN Lookup">
          <Link to="/admin/encounter-mrn-lookup">
            <Search className="h-4 w-4" />
            <span>Encounter MRN Lookup</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Data">
          <Link to="/admin/datasets">
            <Database className="h-4 w-4" />
            <span>Data</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Fields">
          <Link to="/admin/fields">
            <List className="h-4 w-4" />
            <span>Fields</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Templates">
          <Link to="/admin/templates">
            <FileText className="h-4 w-4" />
            <span>Templates</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Test Data">
          <Link to={TEST_DATA_ROUTES.testData.route}>
            <TestTube className="h-4 w-4" />
            <span>Test Data</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Test Runs">
          <Link to="/test-data/runs">
            <GraduationCap className="h-4 w-4" />
            <span>Test Runs</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Clinical Coding">
          <Link to="/admin/clinical-coding">
            <Code className="h-4 w-4" />
            <span>Clinical Coding</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Clinical Code Rules">
          <Link to={CLINICAL_CODE_RULES_ROUTES.clinicalCodeRules.route}>
            <BookOpen className="h-4 w-4" />
            <span>Clinical Code Rules</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Demos">
          <Link to="/demos">
            <Settings className="h-4 w-4" />
            <span>Demos</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Demo Settings">
          <Link to="/admin/demo/settings">
            <Settings className="h-4 w-4" />
            <span>Demo Settings</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip="Settings">
          <Link to={`${USER_ROUTES.settings.route}`}>
            <Settings className="h-4 w-4" />
            <span>Settings</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <div className="flex-1" />
      <SidebarMenuItem>
        <button
          onClick={handleLogout}
          className="flex items-center w-full px-4 py-2 text-red-600 hover:bg-red-50 transition-colors"
          style={{ marginTop: "auto" }}
        >
          <LogOut className="h-4 w-4 mr-2" />
          <span>Logout</span>
        </button>
      </SidebarMenuItem>
    </>
  );
}

export default AdminSidebarMenuItems;
